import axios from 'axios'

export type InquireProductFormInputs = {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  productSku: string
}

type InquireProductResponse = {
  success: boolean
  message: string
}

export const inquireProduct = async (
  inputs: InquireProductFormInputs
): Promise<InquireProductResponse> => {
  const { firstName, lastName, email, phoneNumber, productSku } = inputs

  const fields = [
    {
      name: 'firstname',
      value: firstName,
    },
    {
      name: 'lastname',
      value: lastName,
    },
    {
      name: 'email',
      value: email,
    },
    {
      name: 'phone',
      value: phoneNumber,
    },
    {
      name: 'address', // TODO: create 'productSku' object type in HubSpot
      value: productSku,
    },
  ]

  try {
    const { data } = await axios.post<{ inlineMessage: string }>(
      `https://api.hsforms.com/submissions/v3/integration/submit/${process.env.hubspotTrackingId}/${process.env.hbsptInquireOnlyFormId}`,
      {
        fields: fields,
      }
    )

    return {
      success: true,
      message: data.inlineMessage || 'The inquiry was submitted successfully.',
    }
  } catch (error) {
    return {
      success: false,
      message:
        'There was an error when submitting the inquiry. Please try again later.',
    }
  }
}
